<template>
  <div>
    <div style="padding:20px;background:#fff;border-radius:10px;">
      <exportDate v-if="showExport" @hideExport="hideExport1" :condition="condition" :provinCode="provinCode"
                  :provinceName="provinName" :moduleName="moduleName"/>
      <div>
        <div class="top-div">
          <h4 class="title">
            <span>{{ provinName }}各地区货运平台入网车辆吨位分布统计-</span>
            <dimension-popover :isMapValue="true" :dimObj="dimObj" tabNames="monthly" :change="changeDimension" :showBottomButton="false"
                               :isItemBindClick="true"/>
          </h4>

          <div class="privice-tiem">
            <!-- <span class="demonstration">统计月份 </span>
            <el-date-picker
              v-model="monTime"
              type="month"
              placeholder="选择月"
              @change="changeTime"
              value-format="yyyy-MM"
            ></el-date-picker> -->
            <el-select v-model="fuelType" @change="changeFuelType" style="width:150px;" placeholder="请选择燃油类型">
              <el-option
                  v-for="(item,index) in fuelTypeList"
                  :label="item.label"
                  :value="item.value"
                  :key="index"
              />
            </el-select>
            <el-button v-if="type!=2" @click="goback">返回上一级</el-button>
            <el-button v-show="hideExport" @click="exprotData">导出</el-button>
          </div>
        </div>
        <el-table ref="singleTable" :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
          <el-table-column type="index" width="50" label="序号 " align="center"></el-table-column>
          <el-table-column property="cityName" label="入网地区" align="center"></el-table-column>
          <el-table-column property="totalCout" label="入网车辆数" align="center">
            <template slot-scope='scope'>
              {{ format(scope.row.records ? scope.row.records[0].totalCout : 0) }}
            </template>
          </el-table-column>
          <el-table-column property="first" align="center" label="10吨及以下入网车辆数">
            <template slot-scope='scope'>
              {{ format(scope.row.records ? scope.row.records[0].first : 0) }}
            </template>
          </el-table-column>
          <el-table-column property="second" label="10(含)-25吨入网车辆数" align="center">
            <template slot-scope='scope'>
              {{ format(scope.row.records ? scope.row.records[0].second : 0) }}
            </template>
          </el-table-column>
          <el-table-column property="three" label="25(含)-35吨入网车辆数" align="center" width="160">
            <template slot-scope='scope'>
              {{ format(scope.row.records ? scope.row.records[0].three : 0) }}
            </template>
          </el-table-column>
          <el-table-column property="four" label="35吨(含)以上入网车辆数" align="center" width="160">
            <template slot-scope='scope'>
              {{ format(scope.row.records ? scope.row.records[0].four : 0) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="bottom-top">
      <h4><img src="../../../../assets/images/title.png"> <span>说明</span></h4>
      <div>      1.入网车辆数：按照车籍地统计截至当月的属地化（市/地区）车辆数，例如：冀A12345统计到石家庄，冀B12345统计到唐山，冀C12345统计到秦皇岛。可反映当地重载货车保有量、燃料类型构成、吨位分布。【注】本平台主要统计为12吨及以上的重载普货及半挂牵引车、少量10吨以下的货车。不包括“两客一危”车辆、非营运车辆（如工地的工程车、港口园区内的摆渡车辆、市政的特种运输车辆等）。
      </div>
      <div>       2.吨位划分：以入网车辆总质量的吨位数进行区间划分。
      </div>
      <div>      3.统计频率：按月统计，每月6日更新截至上月数据。
      </div>
    </div>
  </div>
</template>
<script>
// import allData from './index.js'//所有数据
import http from '@/api/freight'
import exportDate from '@/components/exportDate'
import Cookies from 'js-cookie'
import {hideExport} from '@/utils/tools'
import {getFuelTypeList, getFuelTypeCode} from '@/utils/dictionary'
import dimensionPopover from "components/exportDate/daphne/popover.vue";
import get from "lodash/get";

let i = 0
// var now = new Date()
// now.setMonth(now.getMonth() - 1)
export default {
  components: {
    dimensionPopover,
    exportDate
  },
  data() {
    let fuelTypeList = getFuelTypeList();
    return {
      fuelTypeList,
      hideExport: hideExport,
      tableHeight1: this.tableHeight + 100,
      condition: "regist",
      registYear: '',
      registMonth: '',
      i: 0,
      monTime: '', // 默认月份
      tableData: [],
      showExport: false,//控制批量导出
      moduleName: 'vehicleCountCity',
      type: 0,
      montht: 0,
      yeart: 0
    }
  },
  props: {
    year: Number,
    month: Number,
    provinCode: String,
    provinName: String,
    fuelType: String,
    value: {
      default: () => {
        return ''
      },
      type: String
    },
    dimObj: {
      default: () => {
        return {
          year: "2022",
          month: "02",
          type: "0",
        }
      },
      type: Object
    },
  },
  watch: {},
  created() {
  },
  mounted() {
    this.type = Cookies.get('userType');
    console.log(this.type,this.value,this.dimObj)
    this.time=this.type!=2?this.value:this.dimObj.year+'-'+this.dimObj.month
    this.getDatails()
  },
  methods: {
    changeFuelType() {
      this.getDatails()
    },
    format(num) {
      if (num == null || num == undefined) return 0;
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    exprotData() {
      this.showExport = true
    },
    getDatails() {
      var that = this
      let energyType = getFuelTypeCode(this.fuelType);
      let type = get(this,"dimObj.type","0")
      that.tableData=[]
      var month = Number(this.month)
      if (month > 9) {
        month = this.month
      } else {
        month = "0" + this.month
      }
      console.log(that.time)
      http.getCityDataList({
        provinCode: that.provinCode,
        // registMonth: this.month == 0 ? '' : month.toString(),
        // registYear: this.year == 0 ? '' : (that.year).toString(),
        registMonth:that.time.split("-")[1],
        registYear:that.time.split("-")[0],
        condition: that.condition,
        energyType,
      })
          .then(e => {

            that.tableData = e.data.tPageUtil
            let tt = e.data.time
            that.montht = Number(tt.substr(-2));
            that.yeart = Number(tt.substr(0, 4))
            that.monTime = Number(tt.substr(0, 4))+'-'+Number(tt.substr(-2));
          })
    },
    changeDimension(e){
      if(e.isOk){
        this.monTime = e.year+"-"+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.time = arr[0] + '-' + arr[1]
      // let year = time.getFullYear()
      // let month = time.getMonth()
      // that.endMonth = year + that.initMonth(month)
      that.getDatails()
      // that.getData()
    },
    goback() {
      this.$emit("closeDetails")
    },
  }
}
</script>
